import { StoreData } from './StoreData';
import { createStore } from 'redux';

export function isEqual(a, b) {
    if (Object.is(a, b)) {
        return true;
    }
    // Only objects can be equal without being the same.
    if (typeof a !== 'object' || typeof b !== 'object') {
        return false;
    }
    if (Array.isArray(a) !== Array.isArray(b)) {
        return false;
    }
    if (Array.isArray(a)) {
        if (a.length !== b.length) {
            return false;
        }
        for (let i = 0; i < a.length; i++) {
            if (!isEqual(a[i], b[i])) {
                return false;
            }
        }
        return true;
    }
    const keys = new Set();
    for (let i in a) {
        if (!isEqual(a[i], b[i])) {
            return false;
        }
        keys.add(i);
    }
    for (let i in b) {
        if (keys.has(i)) {
            continue;
        }
        if (!isEqual(a[i], b[i])) {
            return false;
        }
    }
    return true;
}

export function assignIfDifferent(a, b) {
    return isEqual(a, b) ? a : b;
}

class PredictableStore {
    constructor(store) {
        if (store) {
            Object.assign(this, store);
            return;
        }
        this.local = {};
        this.stable = new StoreData();
        this.predict = [];
    }

    get current() {
        if (this.predict.length === 0) {
            return this.stable;
        }
        return this.predict[this.predict.length - 1].value;
    }

    _normalize(action) {
        return { ...action, type: '' };
    }

    apply(action) {
        if (action.type === 'local') {
            if (action.value === this.local) {
                return this;
            }
            const copy = new PredictableStore(this);
            copy.local = action.value;
            return copy;
        } else if (action.type === 'predict') {
            const newValue = this.current.apply(action);
            if (newValue === this.current) {
                return this;
            }
            const copy = new PredictableStore(this);
            copy.predict = this.predict.concat([{ action: this._normalize(action), value: newValue }]);
            return copy;
        } else {
            if (this.predict.length > 0) {
                const currentAction = this._normalize(action);
                if (isEqual(this.predict[0].action, currentAction)) {
                    const copy = new PredictableStore(this);
                    copy.stable = this.predict[0].value;
                    copy.predict = this.predict.slice(1);
                    return copy;
                } else {
                    console.log('action differs from prediction: ', currentAction, this.predict[0].action);
                }
            }
            const newValue = this.stable.apply(action);
            if (newValue === this.stable && this.predict.length === 0) {
                return this;
            }
            const copy = new PredictableStore(this);
            copy.stable = newValue;
            copy.predict = [];
            return copy;
        }
    }
}

function reducer(state, action) {
    return state.apply(action);
}

export const store = createStore(reducer, new PredictableStore());
